import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Layer, Rect, Line, Stage } from 'react-konva';
import styles from './styles.less';
import {
  productInfo,
  projectMetadataSelector,
  projectPKSelector,
  selectedSize,
} from '../reducers/selectors';
import { isMobile } from './PicabooResponsive';
import MaterialIcon from './MaterialIcon';
import ZoneOverlayText from './ZoneOverlayText';
import * as Selectors from '../reducers/selectors';
import PicabooConstants from './../common/PicabooConstants';

class ZoneOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dontShowAccepted: false,
    };
  }

  componentDidMount() {
    this.setState({ dontShowAccepted: this.dontShowSelected() });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps != this.props || nextState != this.state;
  }

  render() {
    const { t } = this.props;

    let { containerWidth, containerHeight, pageWidth, pageHeight } = this.props;
    const originalPageWidth = pageWidth;

    const halfPageWidth = pageWidth / 2;

    const widthBase = Math.max(pageWidth, containerWidth);
    const heightBase = Math.max(pageHeight, containerHeight);

    let leftPageEdge = (widthBase - pageWidth) / 2 + 10;
    let topPageEdge = (heightBase - pageHeight) / 2 + 10;

    let pageSafetyX =
      (this.props.selectedSize
        ? this.props.selectedSize.get('safetyX')
        : this.props.productInfo.get('pageSafetyX')) / this.props.ratioBase;
    let pageSafetyY =
      (this.props.selectedSize
        ? this.props.selectedSize.get('safetyY')
        : this.props.productInfo.get('pageSafetyY')) / this.props.ratioBase;

    // if there is no safety for the product, don't worry about displaying it
    if (
      (pageSafetyX === 0 && pageSafetyY === 0) ||
      Number.isNaN(pageSafetyX) ||
      Number.isNaN(pageSafetyY)
    ) {
      return null;
    }

    let pageSafetyLeft = pageSafetyX * originalPageWidth + leftPageEdge;
    let pageSafetyTop = pageSafetyY * originalPageWidth + topPageEdge;

    let pageSafetyRight =
      leftPageEdge + pageWidth - pageSafetyX * originalPageWidth;
    let pageSafetyBottom =
      topPageEdge + pageHeight - pageSafetyY * originalPageWidth;

    let centerSafetyLeft = 0;
    let centerSafetyRight = 0;
    if (this.props.showCenter) {
      centerSafetyLeft =
        leftPageEdge + halfPageWidth - pageSafetyX * originalPageWidth;
      centerSafetyRight =
        leftPageEdge + halfPageWidth + pageSafetyX * originalPageWidth;
    }

    const strokeColor = PicabooConstants.COLORS.SAFETY_COLOR.STROKE_COLOR;
    const strokeTransparency =
      PicabooConstants.COLORS.SAFETY_COLOR.STROKE_TRANSPARENCY;
    const safetyStrokeColor =
      PicabooConstants.COLORS.SAFETY_COLOR.SAFETY_STROKE_COLOR;
    const safetyStrokeTransparency =
      PicabooConstants.COLORS.SAFETY_COLOR.SAFETY_STROKE_TRANSPARENCY;
    const overlayClass = styles.zoneOverlay;

    let zone = {
      bounds: {
        left: leftPageEdge,
        top: topPageEdge,
        right: leftPageEdge + pageWidth,
        bottom: topPageEdge + pageHeight,
      },

      safety: {
        left: pageSafetyLeft,
        top: pageSafetyTop,
        right: pageSafetyRight,
        bottom: pageSafetyBottom,
      },
    };

    const safetyTopHeight = (zone.safety.top - zone.bounds.top) * 2;
    const safetyBottomHeight = (zone.bounds.bottom - zone.safety.bottom) * 2;
    const safetyRightWidth = (zone.bounds.right - zone.safety.right) * 2;
    const safetyLeftWidth = (zone.safety.left - zone.bounds.left) * 2;
    const centerSafetyWidth = centerSafetyRight - centerSafetyLeft;

    const isInsideFrontCover =
      this.props.insideCoverShowing && this.props.pageNumber === 1;
    const isFirstPage =
      this.props.insideCoverShowing && this.props.pageNumber === 2;
    const isLastPage =
      this.props.insideCoverShowing &&
      this.props.pageNumber === this.props.project.get('numPages') + 1;
    const isInsideBackCover =
      this.props.insideCoverShowing &&
      this.props.pageNumber === this.props.project.get('numPages') + 2;
    const zoneOverlayTextWidth = Math.max(
      this.props.twoPage && !this.props.insideCoverShowing
        ? this.props.editorDim.width * 2
        : this.props.editorDim.width,
      1,
    );

    return (
      <>
        {this.props.warningVisible && !this.state.dontShowAccepted && (
          <div
            className={styles.warnOverlay}
            style={{
              position: 'absolute',
              top: isMobile() ? 0 : zone.bounds.top + 10,
              left: isMobile() ? 0 : zone.bounds.left + 10,
            }}
          >
            <MaterialIcon icon="warning" classOverride={styles.fa_warning} />
            <span className={styles.overlayMessage}>
              {t(
                'ZONEOVERLAY.Content near page edges may be trimmed during printing',
              )}
              <div
                id="noShow"
                onClick={() => {
                  this.handleClickDontShow();
                }}
                className={styles.dontShowAgain}
              >
                <input type="checkbox"></input>
                <span>{t('ZONEOVERLAY.Dont show again')}</span>
              </div>
            </span>
          </div>
        )}
        {this.props.cropVisible && (
          <div className={overlayClass}>
            <Stage width={widthBase + 20} height={heightBase + 20}>
              <Layer>
                {!this.props.hideTop && (
                  <Rect
                    x={zone.bounds.left}
                    y={zone.bounds.top}
                    width={zone.bounds.right - zone.bounds.left}
                    height={safetyTopHeight}
                    fill={safetyStrokeColor}
                    opacity={safetyStrokeTransparency}
                  />
                )}

                {!this.props.hideTop && (
                  <Line
                    points={[
                      zone.bounds.left + safetyLeftWidth,
                      zone.safety.top + safetyTopHeight / 2,
                      zone.bounds.right - safetyRightWidth,
                      zone.safety.top + safetyTopHeight / 2,
                    ]}
                    stroke={strokeColor}
                    strokeWidth={1}
                    dash={[2, 2]}
                    opacity={strokeTransparency}
                  />
                )}

                {!this.props.hideBottom && (
                  <Rect
                    x={zone.bounds.left}
                    y={zone.safety.bottom - safetyBottomHeight / 2}
                    width={zone.bounds.right - zone.bounds.left}
                    height={safetyBottomHeight}
                    fill={safetyStrokeColor}
                    opacity={safetyStrokeTransparency}
                  />
                )}

                {!this.props.hideBottom && (
                  <Line
                    points={[
                      zone.bounds.left + safetyLeftWidth,
                      zone.safety.bottom - safetyBottomHeight / 2,
                      zone.bounds.right - safetyRightWidth,
                      zone.safety.bottom - safetyBottomHeight / 2,
                    ]}
                    stroke={strokeColor}
                    strokeWidth={1}
                    dash={[2, 2]}
                    opacity={strokeTransparency}
                  />
                )}

                <>
                  <Rect
                    x={zone.bounds.left}
                    y={zone.bounds.top + safetyTopHeight}
                    width={safetyLeftWidth}
                    height={
                      zone.bounds.bottom -
                      safetyBottomHeight -
                      (zone.bounds.top + safetyTopHeight)
                    }
                    fill={safetyStrokeColor}
                    opacity={safetyStrokeTransparency}
                  />
                  <Line
                    points={[
                      zone.safety.left + safetyLeftWidth / 2,
                      zone.bounds.top + safetyTopHeight,
                      zone.safety.left + safetyLeftWidth / 2,
                      zone.bounds.bottom - safetyBottomHeight,
                    ]}
                    stroke={strokeColor}
                    strokeWidth={1}
                    dash={[2, 2]}
                    opacity={strokeTransparency}
                  />
                </>

                <>
                  <Rect
                    x={zone.safety.right - safetyRightWidth / 2}
                    y={zone.bounds.top + safetyTopHeight}
                    width={safetyRightWidth}
                    height={
                      zone.bounds.bottom -
                      safetyBottomHeight -
                      (zone.bounds.top + safetyTopHeight)
                    }
                    fill={safetyStrokeColor}
                    opacity={safetyStrokeTransparency}
                  />
                  <Line
                    points={[
                      zone.safety.right - safetyRightWidth / 2,
                      zone.bounds.top + safetyTopHeight,
                      zone.safety.right - safetyRightWidth / 2,
                      zone.bounds.bottom - safetyBottomHeight,
                    ]}
                    stroke={strokeColor}
                    strokeWidth={1}
                    dash={[2, 2]}
                    opacity={strokeTransparency}
                  />
                </>

                {this.props.showCenter && (
                  <Rect
                    x={centerSafetyLeft - centerSafetyWidth / 2}
                    y={zone.bounds.top + safetyTopHeight}
                    width={centerSafetyWidth * 2}
                    height={
                      zone.bounds.bottom -
                      zone.bounds.top -
                      safetyTopHeight -
                      safetyBottomHeight
                    }
                    fill={safetyStrokeColor}
                    opacity={safetyStrokeTransparency}
                  />
                )}
              </Layer>
            </Stage>
          </div>
        )}
        {this.props.labelVisible &&
          !(isInsideFrontCover || isInsideBackCover) &&
          (!this.props.hideLeft || this.props.insideCoverShowing) && (
            <ZoneOverlayText
              hideLeft={isFirstPage}
              hideRight={isLastPage}
              width={zoneOverlayTextWidth}
              left={isInsideFrontCover ? this.props.editorDim.width : 0}
              safetyTopHeight={safetyTopHeight}
              safetyBottomHeight={safetyBottomHeight}
              safetyLeftWidth={safetyLeftWidth}
              safetyRightWidth={safetyRightWidth}
              pageWidth={pageWidth}
              pageHeight={pageHeight}
              isCover={this.props.isCover}
              t={this.props.t}
            />
          )}
      </>
    );
  }

  dontShowSelected() {
    let dontShowAccepted = false;
    let s = window.localStorage;
    if (s) {
      const key = this.getDontShowKey();
      let r = s.getItem(key);
      if (r) {
        dontShowAccepted = true;
      }
    }
    return dontShowAccepted;
  }

  getDontShowKey() {
    return `dontshowwarningforproject${this.props.projectPK}`;
  }

  handleClickDontShow() {
    let s = window.localStorage;
    if (s) {
      const key = this.getDontShowKey();
      s.setItem(key, true);
      this.setState({ dontShowAccepted: true });
    }
  }
}

ZoneOverlay.propTypes = {
  containerWidth: PropTypes.number,
  containerHeight: PropTypes.number,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  ratioBase: PropTypes.number,
  cropVisible: PropTypes.bool,
  labelVisible: PropTypes.bool,
  warningVisible: PropTypes.bool,
  hideLeft: PropTypes.bool,
  hideTop: PropTypes.bool,
  hideRight: PropTypes.bool,
  hideBottom: PropTypes.bool,
  showCenter: PropTypes.bool,
  twoPage: PropTypes.bool,
  insideCoverShowing: PropTypes.bool,
  pageNumber: PropTypes.number,
  isCover: PropTypes.bool,
  t: PropTypes.func,
};

export default connect((state) => ({
  productInfo: productInfo(state),
  selectedSize: selectedSize(state),
  projectPK: projectPKSelector(state),
  editorDim: Selectors.editorDimSelector(state),
  project: projectMetadataSelector(state),
}))(ZoneOverlay);
